/* The pools. Carried over from acrostic-v1-app/app/js/seed.js with the rulings intact.
 *
 * Every comment in this file was paid for by a defect. Read before editing. */
/* 130 first names by 110 last names. The old 70 by 60 dealt the same first name to
   adjacent rows on every sorted list (two Tylers, two James, three Lakshmis on one
   console), which reads as generated. No member shares a first name with a staff seat
   (Dana, Marcus, Nina, Simone): "Dana Ortiz, routed to Coach Dana R." was a riddle. */
export const FIRST = [
    'James', 'Maria', 'Wei', 'Priya', 'Carlos', 'Aisha', 'Ryan', 'Sofia', 'Daniel', 'Mei', 'Jorge', 'Emily', 'Hana', 'Tyler', 'Lakshmi', 'Kevin', 'Elena', 'Andre', 'Grace', 'Diego', 'Brandon', 'Fatima', 'Eric', 'Jasmine', 'Victor', 'Chloe', 'Raj', 'Monica', 'Sean', 'Leila', 'Tomas', 'Ivy', 'Nathan', 'Rosa', 'Derek', 'Amara', 'Justin', 'Yuki', 'Omar', 'Kelly', 'Felix', 'Hector', 'Tara', 'Ivan', 'Zoe', 'Miguel', 'Sarah', 'Arjun', 'Bianca', 'Cody', 'Naomi', 'Pablo', 'Erin', 'Samir', 'Holly', 'Trent', 'Alicia', 'Kenji', 'Paige', 'Luis', 'Tessa', 'Devon', 'Anika', 'Cole', 'Maya', 'Ravi', 'Jenna',
    'Owen', 'Beatriz', 'Theo', 'Nadia', 'Gavin', 'Imani', 'Rafael', 'Sienna', 'Mateo', 'Harper', 'Caleb', 'Farah', 'Elliot', 'Rina', 'Julian', 'Ingrid', 'Marco', 'Aaliyah', 'Dev', 'Camila', 'Rohan', 'Freya', 'Isaac', 'Noor', 'Wyatt', 'Talia', 'Nikhil', 'Lena', 'Andres', 'Mira', 'Jonah', 'Celeste', 'Kwame', 'Esme', 'Ezra', 'Dalia', 'Aiden', 'Leah', 'Bruno', 'Keiko', 'Malik', 'Ines', 'Xavier', 'Ayesha', 'Reuben', 'Simran', 'Lucas', 'Marisol', 'Adrian', 'Thandi', 'Emmett', 'Salma', 'Tobias', 'Ximena', 'Hugo', 'Aurora', 'Rafi', 'Priyanka', 'Idris', 'Jade', 'Silas', 'Kavya', 'Leon', 'Odette',
];
export const LAST = [
    'Chen', 'Rodriguez', 'Patel', 'Nguyen', 'Kim', 'Garcia', 'Smith', 'Johnson', 'Lee', 'Martinez', 'Wong', 'Brown', 'Sharma', 'Lopez', 'Tran', 'Davis', 'Wilson', 'Hernandez', 'Park', 'Taylor', 'Gupta', 'Rivera', 'Yang', 'Moore', 'Silva', 'Ali', 'Thompson', 'Sanchez', 'Huang', 'White', 'Reddy', 'Ortiz', 'Lin', 'Clark', 'Mendoza', 'Iyer', 'Ramos', 'Baker', 'Nakamura', 'Flores', 'Kaur', 'Adams', 'Cruz', 'Ho', 'Bennett', 'Vargas', 'Shah', 'Murphy', 'Castillo', 'Cooper', 'Das', 'Reyes', 'Fujita', 'Bailey', 'Romero', 'Kapoor', 'Brooks', 'Delgado', 'Watanabe', 'Hayes',
    'Okafor', 'Lindqvist', 'Abara', 'Moreau', 'Haddad', 'Petrov', 'Dube', 'Sato', 'Villanueva', 'Costa', 'Osei', 'Bergström', 'Rahman', 'Duarte', 'Novak', 'Achebe', 'Fischer', 'Mbeki', 'Quintero', 'Sullivan', 'Kowalski', 'Farouk', 'Ibarra', 'Tanaka', 'Mensah', 'Oyelaran', 'Marchetti', 'Serrano', 'Bakshi', 'Whitaker', 'Eriksen', 'Nwosu', 'Aguilar', 'Pereira', 'Halvorsen', 'Dlamini', 'Rossi', 'Chaudhry', 'Larsen', 'Barros', 'Kowal', 'Oduya', 'Ferreira', 'Mehta', 'Ochoa', 'Salazar', 'Andersen', 'Banerjee', 'Molina', 'Lucero',
];
/* ── Faces ──────────────────────────────────────────────────────────────────
   Every person in the demo has a face (owner ruling 2026-09-04: "replace all acronyms
   as pfp and add images for each member, making it feel human"). The portraits are
   AI-generated stock faces normalised to 128px, gender-matched to the first-name pool,
   dealt out in order from two pools so no two people share one. A share of brand-new
   members and fresh leads deliberately has none: that is what the photo upload on
   Edit details is for, and the initials fallback has to stay exercised. */
export const FEMALE = new Set([
    'Maria', 'Priya', 'Aisha', 'Sofia', 'Mei', 'Emily', 'Hana', 'Lakshmi', 'Elena', 'Grace', 'Nina', 'Fatima', 'Jasmine', 'Chloe', 'Monica', 'Leila', 'Ivy', 'Rosa', 'Amara', 'Yuki', 'Kelly', 'Dana', 'Tara', 'Zoe', 'Sarah', 'Bianca', 'Naomi', 'Erin', 'Holly', 'Alicia', 'Paige', 'Tessa', 'Anika', 'Maya', 'Jenna',
    'Beatriz', 'Nadia', 'Imani', 'Sienna', 'Harper', 'Farah', 'Rina', 'Ingrid', 'Aaliyah', 'Camila', 'Freya', 'Noor', 'Talia', 'Lena', 'Mira', 'Celeste', 'Esme', 'Dalia', 'Leah', 'Keiko', 'Ines', 'Ayesha', 'Simran', 'Marisol', 'Thandi', 'Salma', 'Ximena', 'Aurora', 'Priyanka', 'Jade', 'Kavya', 'Odette',
]);
export const FACE_POOL = { f: 171, m: 176 };
export const COACHES = ['Coach Marcus J.', 'Coach Dani K.', 'Coach Alex T.', 'Coach Sam K.', 'Coach Rita M.', 'Coach Leo P.'];
/* The gym's SUPPORT roster: who a member or prospect is ASSIGNED to. Deliberately not
   the class instructors above. Two different populations, both called "coach". */
export const SUPPORT_ROSTER = ['Coach Dana R.', 'Coach Marcus L.', 'Coach Priya S.', 'Coach Tomas W.'];
export const FRONT_DESK = ['Nina Alvarez', 'Cole Barrett'];
export const SCHEDULE = [
    { time: '6:00 AM', name: 'Signature 45', instructor: 'Coach Marcus J.', cap: 20 },
    { time: '9:00 AM', name: 'Strength & Conditioning', instructor: 'Coach Dani K.', cap: 20 },
    { time: '11:00 AM', name: 'Open Gym', instructor: 'Self-Guided', cap: 30 },
    { time: '12:00 PM', name: 'HIIT Circuit', instructor: 'Coach Marcus J.', cap: 20 },
    { time: '3:00 PM', name: 'Small Group PT', instructor: 'Coach Alex T.', cap: 15 },
    { time: '5:30 PM', name: 'Signature 45', instructor: 'Coach Dani K.', cap: 20 },
    { time: '6:30 PM', name: 'Boxing Conditioning', instructor: 'Coach Rita M.', cap: 20 },
    { time: '7:30 PM', name: 'Mobility & Recovery', instructor: 'Coach Sam K.', cap: 15 },
];
/* ── Where people come from ───────────────────────────────────────────────────
   The mix is a boutique studio's: Website 30 · Funnel 30 · Walk-in 12 · Event 10 ·
   Class Pass 10 · Phone 8. The old pool ('Instagram Ads', 'Community Event') matched
   none of the category rules, so every lead on the board read "Uncategorised (legacy)". */
export const SOURCE_MIX = [
    ['Website', 0.30], ['Funnel', 0.30], ['Walk-in', 0.12], ['Event', 0.10], ['Class Pass', 0.10], ['Phone', 0.08],
];
export const FUNNEL_SUBS = ['Meta Ads', 'Meta Ads', 'Meta Ads', 'Meta Ads', 'Google Search Ads', 'Google Search Ads', 'Google Search Ads', 'Instagram', 'Instagram'];
export const EVENT_NAMES = ['Saturday Open House', 'Spring 5K Expo', 'Downtown Farmers Market', 'Summer Strong Launch Night', 'Charity Bootcamp', 'Willow Glen Wellness Fair', 'Bring a Friend Saturday'];
/* "How did you hear about us?" is a different question from the source: a website form
   from someone a member told about the place is source Website, heard "Friend or member". */
export const HEARD_BY_SOURCE = {
    'Website': ['Google Search', 'Google Search', 'Instagram', 'Website', 'YELP'],
    'Walk-in': ['Walked or drove past', 'Walked or drove past', 'Google Search'],
    'Event': ['Event'],
    'Phone': ['Google Search', 'YELP', 'Website'],
};
export const PLANS = [
    { name: 'Unlimited Membership', price: 399, w: 0.38 },
    { name: 'Unlimited + 2x PT', price: 549, w: 0.12 },
    { name: '12 Sessions / Month', price: 299, w: 0.18 },
    { name: '8 Sessions / Month', price: 229, w: 0.10 },
    { name: 'Foundations (6-wk)', price: 199, w: 0.07 },
    { name: 'Legacy Unlimited', price: 349, w: 0.15 },
];
export const GOALS = ['Fat loss', 'Build muscle', 'General fitness', 'Athletic performance', 'Post-injury rebuild'];
/* WHY they are here, in their own words: the reason behind the goal, not the goal.
   Shared pool, so THEY/THEM ONLY and nothing in the first person. A gendered line here
   landed "Introduced herself to the Tuesday regulars" three notes above "Wants to bring
   his partner to a trial" on one person's own record. */
export const WHY = [
    'Wants to keep up with the kids at the park without needing the bench.',
    'Turned 50 and decided the next decade would be a strong one.',
    'A doctor said the word "pre-diabetic" and that was enough.',
    'Training for the Big Sur half in April, and finishing it running.',
    'Back pain from twelve years at a desk. Never wants to feel it again.',
    'Wedding in the autumn. Wants to feel good in the photos, not just look it.',
    'Moved here for work and this is where the friends came from.',
    'Grew up playing soccer and misses being part of a team.',
    'Wants to carry a suitcase up three flights without thinking about it.',
    'Post-partum, and this is the one hour a week that is not about anyone else.',
    'Coming back from a knee reconstruction and wants the old strength back.',
    'Wants to be the parent who still hikes with grown-up children.',
    'Sleep was a mess. Mornings here fixed it, so mornings here stay.',
    'Stopped starting over every January. This is the year it stuck.',
    'A parent had a heart attack at 58. Not planning to repeat it.',
    'Wants to deadlift bodyweight before the next birthday.',
    'Works nights. This is the only routine that survived the shift change.',
    'Skiing in February and wants the legs to last a full day.',
    'The 6am crew is the reason. The workout is almost secondary.',
    'Wants to stop feeling winded on the third flight of stairs.',
    'Rebuilding after a hard year. This is the fixed point in the week.',
    'A first 10k done. Now a half marathon without walking any of it.',
    'Wants the confidence back that went missing somewhere in the thirties.',
    'Doctor flagged blood pressure. The plan is to fix it without pills.',
    'Two young kids and a body that needs to keep up with them.',
    'Golf swing lost twenty yards. Wants them back.',
    'Retired last year and needed somewhere to be at 9am.',
];
/* A line that implies a body ("Post-partum") is dealt only to someone whose portrait is
   drawn from the f- pool: the face pool is picked by first name, so the same test picks
   the why. Until 2026-09-04 a member with an m- portrait could carry a post-partum why. */
export const BODY_LINE = /post-partum|pregnan/i;
export const OCCUPATIONS = ['Tech', 'Tech', 'Tech', 'Business', 'Business', 'Medicine', 'Teacher', 'Student', 'Homemaker', 'Service (Police/Fire)', 'Others'];
export const CITIES = [['San Jose', '95125'], ['San Jose', '95126'], ['San Jose', '95128'], ['Campbell', '95008'], ['Los Gatos', '95030'], ['Santa Clara', '95050'], ['Willow Glen', '95125']];
export const STREETS = ['Lincoln Ave', 'Meridian Ave', 'Bird Ave', 'Hamilton Ave', 'Bascom Ave', 'Minnesota Ave', 'Curtner Ave', 'Pine Ave', 'Willow St', 'Coe Ave'];
export const ANYTHING_ELSE = [
    'Prefers a heads-up before any partner work.',
    'Would like the Saturday session to start later.',
    'Interested in the nutrition workshop when there is one.',
    'Has trained with a coach before and liked being pushed.',
    'Shift worker, so the schedule moves month to month.',
    'Brings a friend now and then, would like a guest pass or two.',
];
export const GOAL_12M = [
    'Be the strongest version of this body so far.',
    'Run the half without stopping and recover by the next day.',
    'Drop two sizes and keep them off through the holidays.',
    'Train three times a week, every week, for a whole year.',
    'Back and shoulders that no longer complain after a work week.',
    'Keep up with the kids on a full day out and still have something left.',
];
export const GOAL_100D = [
    'Twelve sessions a month, no missed weeks.',
    'First unassisted pull-up.',
    'Deadlift bodyweight for five.',
    'Lose the first ten pounds and rebuild the morning routine.',
    'Finish the 5K in under thirty minutes.',
    'A full push-up set without dropping to the knees.',
];
export const AFP_GOAL = { 'Fat loss': 'Weight Loss', 'Build muscle': 'Muscle Gain', 'General fitness': 'Be Healthier', 'Athletic performance': 'Build Strength', 'Post-injury rebuild': 'Feel Better' };
export const MKT_GOAL = { 'Fat loss': 'Lose weight / body composition', 'Build muscle': 'Build strength and fitness', 'General fitness': 'General health and longevity', 'Athletic performance': 'Improve athletic performance', 'Post-injury rebuild': 'Recover from injury' };
/* The home session's clock time, as both intake forms ask for it. */
export const TIME_PREF = {
    '6:00 AM': ['Early morning (5–8am)', 'Early mornings - between 6am and 8am'],
    '9:00 AM': ['Morning (8–11am)', 'Late mornings - between 8am and 10am'],
    '11:00 AM': ['Midday (11am–2pm)', 'Early afternoons - between 11am and 3pm'],
    '12:00 PM': ['Midday (11am–2pm)', 'Early afternoons - between 11am and 3pm'],
    '3:00 PM': ['Afternoon (2–5pm)', 'Late afternoons - between 4pm and 6pm'],
    '5:30 PM': ['Evening (5–8pm)', 'Late afternoons - between 4pm and 6pm'],
    '6:30 PM': ['Evening (5–8pm)', 'Evenings - between 6pm and 9pm'],
    '7:30 PM': ['Evening (5–8pm)', 'Evenings - between 6pm and 9pm'],
};
/* ── Anchors ──────────────────────────────────────────────────────────────────
   An anchor is a NAMED, RECIPROCAL relationship inside the club, not an assignment.
   Every anchor carries `basis` (what actually makes it two-way) and `lastTwoWay`.
   Zero anchors is the signal, not the absence of one. */
export const ANCHOR_BASIS = [
    'Same 6am class three times a week for two years',
    'Coached them back from a knee reconstruction',
    'Knows their kids by name, they come to the Saturday session',
    'Signed them up personally at a community event',
    'Asks about their marathon block every single week',
    'Checked in through their father’s illness, unprompted',
    'Spots them on every heavy lift',
    'Both run with the same club on Sundays',
    'Talked them out of quitting in their first month',
    'Covers their 5.30 whenever their shift moves',
];
export const PARTNER_BASIS = [
    'Books every class together',
    'Referred them, still train side by side',
    'Drive in together most mornings',
    'Met here, now training partners',
];
export const INHERITED_BASIS = [
    'Ran both trials before they joined',
    'Answered their first enquiry and closed it',
    'Walked them round on their first visit',
];
/* ── Care Track & Hold ────────────────────────────────────────────────────────
   Two suppression kinds, both of which take a member OFF the risk model entirely.
   Suppression is "away, not gone": no score, no ranking, no automated message.
   This is the one bug in this app that would cause real harm to a real person. */
export const CARE_REASONS = [
    'Knee surgery: cleared for upper body only',
    'Post-partum, returning when ready',
    'Bereavement: lost a parent in January',
    'Long COVID, energy still unpredictable',
    'Shoulder impingement, under physio',
    'Caring for a partner through chemotherapy',
    'Stress fracture, eight weeks non-weight-bearing',
];
/* A hold names how long, never a month or a season: "back in March" read as a lie on a
   record whose review date fell in a different month. `weeks` is the span the review
   date is placed inside, counted from the day the hold was declared. */
export const HOLD_REASONS = [
    { text: 'Away for work for a few weeks, membership held at their request', weeks: [4, 7] },
    { text: 'Travelling for about a month, back before the review date', weeks: [4, 6] },
    { text: 'Sabbatical, told us in advance', weeks: [8, 12] },
    { text: 'Deployed, membership held at their request', weeks: [10, 16] },
    { text: 'Studying overseas for a term', weeks: [10, 14] },
];
/* What staff actually learn in ordinary conversation: the Detail Ledger. Their absence
   is what made every member's Recent notes card read "Nothing logged yet".
   Shared pool: THEY/THEM ONLY. */
export const MEMBER_NOTES = {
    any: [
        'Prefers the 6am. Says the evening classes are too busy.',
        'Knee grumbling since the weekend: scaled the lunges, no complaints after.',
        'New job means Tuesdays are out for the next month.',
        'Asked about the nutrition workshop. Send the date when it is set.',
        'Brought a friend to the Saturday session.',
        'Hit a PB on the trap-bar deadlift. Very pleased.',
        'Travelling for work the last week of the month.',
        'Mentioned the 5.30 coach by name. Likes training with that coach.',
        'Wants a second session a week but is nervous about recovery.',
        'Daughter starts school in September, so mornings may free up.',
        'Back from holiday. Straight back in on the Monday.',
        'Asked whether we do anything for shoulders specifically.',
        'Struggling with sleep. Suggested moving off the late class.',
        'First time doing a full push-up. Genuinely delighted.',
        'Said the playlist on Thursdays is the reason they come.',
        'Wants to bring their partner to a trial.',
        'Missed two weeks with a chest infection. Back and taking it easy.',
        'Bought new shoes. Wanted somebody to notice.',
        'Asked about protein timing, passed to the coach rather than guessing.',
        'Sister is getting married in June: that is the deadline in their head.',
        'Prefers not to be put in the front row. Noted.',
        'Cancelled Thursday, rebooked Friday without being chased.',
        'Reported the changing room heater. Passed to the manager.',
        'Wrist niggle from work, not from training. Watching it.',
        'Told a coach this is the longest they have stuck at anything.',
        'Wants to try the boxing class but is embarrassed to be new again.',
        'Car broke down, missed the 6am, came at lunch instead.',
        'Asked about pausing over Christmas rather than cancelling.',
        'Introduced themselves to the Tuesday regulars unprompted.',
        'Said the check-in by name is why they keep coming back.',
        'Deadlift form finally clicked. Coach spent ten minutes on it.',
        'Working late all month, moved to weekend sessions.',
        'Mentioned money is tight but did not ask for anything.',
        'Ran a 10k at the weekend. First one.',
        'Wants a programme they can do while travelling.',
        'Prefers text to email. Updated the record.',
    ],
    committed: [
        'Asked about coaching others, might be worth a conversation.',
        'Two years this month. Worth marking.',
    ],
    fading: [
        'Has not been in since the schedule change. Said the new time does not work.',
        'Answered the text but did not book. Try a call rather than a message.',
    ],
    at_risk: [
        'Left a voicemail, no reply. Second attempt next week.',
        'Said work has been "mad" for a month. Offered to hold a slot.',
    ],
    new: [
        'First session done. Nervous but stayed for the whole class.',
        'Induction booked with the morning coach.',
    ],
};
/* WHY a lead is here, in their words. Off the enquiry form, so EVERY lead has one,
   including the ones nobody has called yet. Shared pool: they/them only. */
export const LEAD_WHY = [
    'Wants to keep up with their kids without getting winded.',
    'Turning 40 next year and does not want to feel it.',
    'Back pain from a desk job. Physio said start strength work.',
    'Got out of a long relationship and wants something that is just for them.',
    'Wedding in seven months.',
    'Used to play rugby. Misses having a team.',
    'Doctor flagged blood pressure at the last check-up.',
    'Works nights and has lost any kind of routine.',
    'Wants to carry the shopping up three flights without stopping.',
    'A sibling trains here and will not stop talking about it.',
    'Post-partum, wants to feel like themselves again.',
    'Wants to run the half marathon in March without walking any of it.',
    'New to the city and does not know anybody yet.',
    'Sat down after a knee op and never really got back up.',
    'Wants to stop starting over every January.',
    'Training for a hike in Patagonia in the spring.',
];
export const LEAD_NOTES = {
    contacted: [
        'Called back within the hour. Wants to train mornings before work.',
        'Left a voicemail, then texted. Asked about parking.',
        'Picked up on the second ring, booking a trial for Thursday.',
        'Nervous about walking in alone. Offered to meet them at the desk.',
    ],
    prospect_1: [
        'First trial done. Loved the coach, found the music loud.',
        'Came to Signature 45. Said it was harder than expected but wants the second one.',
        'Trial one done, asked whether there is anything gentler on the knees.',
        'Enjoyed it. Friend already trains here, which is how they heard about us.',
    ],
    prospect_2: [
        'Both trials done. Comparing us against the studio near their office.',
        'Second trial done: the 6am slot works, the 5.30pm does not.',
        'Ready in principle, waiting on payday before committing.',
        'Wants to know if membership can be paused over the holidays.',
    ],
    nurture: [
        'Not ready yet. New job starting, asked us to check back next month.',
        'Went quiet after the second trial. One message sent, no reply.',
        'Budget is the sticking point, not the training.',
        'Travelling for six weeks. Genuinely wants to start when back.',
    ],
    won: [
        'Signed up on the spot after the second trial.',
        'Joined on Unlimited. Wants to start with the morning group.',
    ],
    lost: [
        'Joined the studio closer to home. No hard feelings, said to stay in touch.',
        'Price was the reason. Was honest about it.',
        'Stopped replying after the second trial.',
    ],
};
/* A lead's anchor is the support coach who owns them. A `new` lead has NONE: an anchor
   is reciprocal, and a form submission is not a relationship. A won lead's anchor is the
   one that gets INHERITED on conversion, so it must exist here or the relationship has
   nothing to carry across. A lost lead keeps theirs too: the win-back at day 45 goes out
   from the person they actually knew, not from the club. */
export const LEAD_BASIS = {
    contacted: 'Answered their first call',
    prospect_1: 'Ran their first trial',
    prospect_2: 'Ran both trials with them',
    nurture: 'Stayed in touch after the trials',
    won: 'Signed them up personally',
    lost: 'Ran their trials, they did not join',
};
export const NEXT_ACTION = {
    new: 'First response within the hour, from a named person',
    contacted: 'Book their first trial class',
    prospect_1: 'Completed first trial: book the second trial',
    prospect_2: 'Both trials done: membership close call (share InBody results)',
    nurture: 'Trials done, not converted: add to nurture sequence',
    won: 'Start 90-day onboarding sequence',
    lost: 'Add to 90-day win-back campaign',
};
/* Interactions: a call or a message a NAMED person made. Nothing invented that the
   product could not know. */
export const CALL_LINES = [
    'Phone call: talked through the class times that actually work.',
    'Phone call: checked in after the gap. Nothing wrong, work has been heavy.',
    'Phone call: no answer, left a voicemail.',
    'Called to say the lunch slot has space if the mornings are hard.',
];
export const SMS_LINES = [
    'Message sent: "Good to see you back this week."',
    'Message sent: "We have missed you. Anything we can do to make it easier?"',
    'Message sent: "Your InBody is due, want me to book it?"',
];
/* WHAT THE MEMBER SAYS BACK (PRD 6, the Conversation tab).
 *
 * The thread was one-sided: every SMS in the seed was the gym talking. A member
 * record whose conversation is entirely outbound says the gym broadcasts, which is
 * the opposite of what this product is for, and the tab would have shipped looking
 * like a send log.
 *
 * Two thirds are ordinary and warm, because most replies are. The awkward ones are
 * here on purpose: they are what the four topics AI never handles look like in a
 * real thread, and a demo where every member replies happily is not one anybody
 * recognises. */
export const SMS_REPLIES = [
    'Thanks! Back in on Thursday.',
    'Sorry, been flat out at work. Aiming for the weekend.',
    'Yes please, book me in.',
    'Can we do the 6am instead? The evening one is not working any more.',
    'That is kind of you to check.',
    'Knee is still sore honestly. Might give it another week.',
    'Just seen this, sorry. Yes I will come along.',
    'Been meaning to ask what the options are if I need to pause for a bit.',
    'Got it, thank you.',
    'Is there a cheaper plan? Things are a bit tight at the moment.',
];
export const INPERSON_LINES = [
    'Stopped them on the way out: knee is holding up.',
    'Introduced them to two of the morning regulars.',
    'Talked after class about scaling the lunges.',
];
/* Items 5 and 6: a follow-up records what came BACK, not just what was due. Without the
   outcome nothing can learn which actions actually lead to a return. */
export const OUTCOMES = [
    { outcome: 'Replied', detail: 'Interested in new timing', status: 'in_progress' },
    { outcome: 'No response', detail: 'Follow up again', status: 'overdue' },
    { outcome: 'Call completed', detail: 'Not ready, follow up later', status: 'completed' },
    { outcome: 'Meeting scheduled', detail: 'Booked in this week', status: 'in_progress' },
    { outcome: 'Returned to class', detail: 'Back in on Tuesday', status: 'completed' },
];
/* ── Roster size ────────────────────────────────────────────────────────────
   The shipped demo is 287 members and that is what a normal visit gets. A bigger roster
   is asked for explicitly, because the real tenants are bigger: FNS is 2,951. */
export const DEFAULT_MEMBERS = 287;
/* DORMANT taken out of `committed` rather than added on top, so the roster is still
   287 and 261 current and the counts every test asserts do not move. They are real
   at a real gym — an active membership nobody has seen since last winter — and
   without them the Dormant segment and the console's exclusion of it are code
   nothing on the screen demonstrates. */
export const MEMBER_MIX = [
    ['committed', 109], ['steady', 74], ['fading', 33], ['at_risk', 7], ['dormant', 9],
    ['new', 15], ['trial', 8], ['frozen', 6], ['cancelled', 26],
];
export const LEAD_MIX = [
    ['new', 9], ['contacted', 12], ['prospect_1', 8], ['prospect_2', 6], ['nurture', 5], ['won', 5], ['lost', 3],
];
/* Re-exported from the model so the seed deals only reasons the product offers. */
export { DROPOUT_REASONS } from '@acrostic/model';
